import { lazy, Suspense, useEffect, useState } from "react";
import { Bot, X } from "lucide-react";
import { getConsent } from "@/components/CookieBanner";

// Le panneau (et tout appel API) n'est chargé qu'après acceptation des cookies ou au premier clic sur la bulle
const ChatPanel = lazy(() => import("@/components/ChatPanel"));

export default function ChatWidget() {
  const [open, setOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (getConsent() === "accepted") setLoaded(true);
    const onConsent = () => setLoaded(true);
    window.addEventListener("vgi-cookies-accepted", onConsent);
    return () => window.removeEventListener("vgi-cookies-accepted", onConsent);
  }, []);

  const toggle = () => { setLoaded(true); setOpen(o => !o); };

  return (
    <>
      <button data-testid="chat-toggle" aria-label="Assistant IA" aria-expanded={open} onClick={toggle}
        style={{ position: 'fixed', bottom: '24px', left: '24px', zIndex: 9998, width: '56px', height: '56px', borderRadius: '50%', backgroundColor: '#8B0000', border: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 16px rgba(139,0,0,0.4)', cursor: 'pointer' }}>
        {open ? <X size={26} color="#fff" /> : <Bot size={28} color="#fff" />}
      </button>
      {loaded && (
        <Suspense fallback={null}>
          <ChatPanel open={open} />
        </Suspense>
      )}
    </>
  );
}
